// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"678":"aa43365e4e123a893ca9","731":"ee0986ab8e9f7489c4f5","843":"bd678e42b16830e431dd","883":"5913cfe0340aae68dcc4"}[chunkId] + ".js";
};